import IconButton from '@material-ui/core/IconButton';
import {
  DoneAll,
  GroupAdd,
  LocalLibrary,
  Print,
  TabletAndroid,
  Visibility,
} from '@material-ui/icons';
import useRole from 'components/GenericsHooks/useRoles';
import {TwoParamsOption} from 'components/grid-dx/types';
import PopupRemove from 'components/Popups/PopupRemove';
import {i18n2} from 'features/i18n/i18n';
import {useSendDataToBack} from 'features/instance-manager/hooks';
import React, {useState, forwardRef} from 'react';
import {Link} from 'react-router-dom';
import {PrintReportForm, TakeAssistantForm} from '../form/index';
import {useActionButtonStyles} from 'components/grid-dx/styles/actionButtonStyles';
import {useIsTablet} from 'components/hooks/useIsTablet';

export const MAX_ACTION_BUTTONS = 4;

const PrintAssistants = ({row, isTablet}: any) => {
  const [openPrintAssistants, setOpenPrintAssistants] = useState(false);
  const styles = useActionButtonStyles();
  if (row.modality === 2 && (row.status === 0 || row.status === 3)) {
    return (
      <>
        <IconButton
          size="small"
          title={i18n2._('Print sheet')}
          className={isTablet ? styles.tabletButton : styles.compactButton}
          onClick={() => setOpenPrintAssistants(true)}>
          <Print
            className={isTablet ? styles.tabletIcon : styles.compactButton}
          />
        </IconButton>
        {openPrintAssistants && (
          <PrintReportForm
            id_course={row.iD_Course}
            id_instance={row.iD_Instance}
            open={openPrintAssistants}
            setOpen={setOpenPrintAssistants}
          />
        )}
      </>
    );
  } else {
    return null;
  }
};

const Present = ({row, isTablet}: any) => {
  const styles = useActionButtonStyles();
  const [openPresent, setOpenPresent] = useState(false);

  if (row.modality === 2 && (row.status === 0 || row.status === 3)) {
    return (
      <>
        <IconButton
          size="small"
          title={i18n2._('Tomar asistencia')}
          className={isTablet ? styles.tabletButton : styles.compactButton}
          onClick={() => setOpenPresent(true)}>
          <LocalLibrary
            className={isTablet ? styles.tabletIcon : styles.compactButton}
          />
        </IconButton>
        {openPresent && (
          <TakeAssistantForm
            id_course={row.iD_Course}
            id_instance={row.iD_Instance}
            open={openPresent}
            setOpen={setOpenPresent}
          />
        )}
      </>
    );
  } else {
    return null;
  }
};

const SendDataToBack = ({row, isTablet}: any) => {
  const styles = useActionButtonStyles();
  const sendData = useSendDataToBack();
  const [openSignature, setOpenSignature] = useState(false);
  const [redirect, setRedirect] = useState(false);
  const [twoParamsOptions, setTwoParamsOptions] = useState<TwoParamsOption>({
    AddedOne: null,
    AddedTwo: [],
  });

  if (row.modality !== 0 && (row.status === 0 || row.status === 3)) {
    return (
      <>
        <IconButton
          size="small"
          title={i18n2._('Confirmar operación')}
          className={isTablet ? styles.tabletButton : styles.compactButton}
          onClick={() => {
            const payload = {
              id_instance: row.iD_Instance,
              id_course: row.iD_Course,
            };

            setTwoParamsOptions({
              AddedOne: payload,
              AddedTwo: [],
            });

            setOpenSignature(true);
          }}>
          <DoneAll
            className={isTablet ? styles.tabletIcon : styles.compactButton}
          />
        </IconButton>
        {openSignature && (
          <PopupRemove
            open={openSignature}
            setOpen={setOpenSignature}
            redirect={redirect}
            setRedirect={setRedirect}
            promiseToReturn={sendData}
            types={twoParamsOptions}
            url={'/Dashboard'}
            text={i18n2._(
              '¿Desea finalizar la instancia? Una vez aceptado la instancia estara finalizada y no se podra seguir editando',
            )}
          />
        )}
      </>
    );
  } else {
    return null;
  }
};

const SignatureAndAddTablet = ({row, isTablet}: any) => {
  const styles = useActionButtonStyles();
  if (row.modality === 1) {
    return (
      <>
        <IconButton
          component={(props: any) => (
            <Link
              to={{
                pathname: '/TabletCourse',
                state: {
                  data: {
                    iD_Instance: row.iD_Instance,
                    iD_Course: row.iD_Course,
                    employee_Nr: row.employee_Nr,
                    status: row.status,
                  },
                },
              }}
              {...props}
            />
          )}
          size="small"
          title={i18n2._('Tomar curso')}
          className={isTablet ? styles.tabletButton : styles.compactButton}>
          {row.status === 3 || row.status === 0 ? (
            <TabletAndroid
              className={isTablet ? styles.tabletIcon : styles.compactButton}
            />
          ) : (
            <Visibility
              className={isTablet ? styles.tabletIcon : styles.compactButton}
            />
          )}
        </IconButton>
      </>
    );
  } else {
    return null;
  }
};

const AddAssistants = ({row, id, isTablet}: any) => {
  const styles = useActionButtonStyles();
  const role = useRole();
  let url = '/Management-Instance';
  if (row.status === 3) {
    return (
      <>
        <IconButton
          component={forwardRef((props: any, ref) => (
            <Link
              to={{
                pathname: url,
                state: {data: row, key: id, roles: role},
              }}
              {...props}
              ref={ref}
            />
          ))}
          size="small"
          title={i18n2._('Add assistants')}
          className={isTablet ? styles.tabletButton : styles.compactButton}>
          <GroupAdd
            className={isTablet ? styles.tabletIcon : styles.compactButton}
          />
        </IconButton>
      </>
    );
  } else {
    return null;
  }
};

const Buttons = ({data, id}: any) => {
  const styles = useActionButtonStyles();
  const isTablet = useIsTablet();

  return (
    <div
      className={isTablet ? styles.tabletContainer : styles.compactContainer}>
      <AddAssistants row={data} id={id} isTablet={isTablet} />
      <PrintAssistants row={data} isTablet={isTablet} />
      <SignatureAndAddTablet row={data} isTablet={isTablet} />
      <Present row={data} isTablet={isTablet} />
      <SendDataToBack row={data} isTablet={isTablet} />
    </div>
  );
};

export default Buttons;
